import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { RoleService, SystemsService, isNotNullOrUndefined, ADVANCED_PLANTS_LIMIT } from 'ngx-core-services';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlatinumGuard implements CanActivate {

  constructor(
    private readonly roleService: RoleService,
    private readonly router: Router,
    private readonly systemsService: SystemsService,
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {

    const advancedPlants = await this.systemsService._awsSystems$.pipe(
      isNotNullOrUndefined(),
      first(),
    ).toPromise();

    const has_somePermission = await this.roleService.has_somePermission$.pipe(
      isNotNullOrUndefined(),
      first(),
    ).toPromise();

    if (has_somePermission || advancedPlants?.length <= ADVANCED_PLANTS_LIMIT) {
      if (state.url === '/account-error') {
        return this.router.createUrlTree(['/']);
      }
      return true;
    }

    if (state.url === '/account-error') {
      return true;
    }
    return this.router.createUrlTree(['/account-error']);
  }
}
